import Vue from 'vue'
import Vuex from 'vuex'
import UserModule from '@/store/modules/user';
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({ storage: window.localStorage })

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    user: UserModule
  },
  plugins: [vuexLocal.plugin]
})


